import type { LandBounceTuning } from "@slot/presentation";

/**
 * Per-game VALUE for the FS-landing grid bounce. Shape from the presentation's
 * `LandBounce` land reaction; this game dips `layoutRoot` when an `FS` scatter
 * lands. Durations are clock-scaled; tune by eye.
 */
export const LAND_BOUNCE_TUNING: LandBounceTuning = {
  pixels: 10,
  downSeconds: 0.08,
  upSeconds: 0.18,
  easing: "backOut",
};
